<template>
    <div class="popup" v-show="show">
        <div class="pointDetail bg_white">
            <Icon class="closer cursor_pointer" type="md-close" @click="show=false" size="26"/>
            <div v-if="flag==='create'" class="title f18 bold500 txt_black87 tc">新建点位</div>
            <div v-if="flag==='edit'" class="title f18 bold500 txt_black87 tc">编辑点位</div>
            <div class="page" v-show="page===0">
                <div class="content">
                    <div class="fl item txt_black54 f14 bold500">
                        <div class="title bold600 content-center">
                            <Icon type="ios-star"/>
                            点位名称：
                        </div>
                        <div class="ipt">
                            <input class="w100 h100" type="text" placeholder="请输入点位名称" v-model="data.name"/>
                        </div>
                    </div>

                    <div class="fr item txt_black54 f14 bold500">
                        <div class="title bold600 content-center">
                            <Icon type="ios-star"/>
                            点位坐标：
                        </div>
                        <div class="ipt">
                            <input class="h100" style="width: 48%" type="text" placeholder="请输入X坐标" v-model="data.location.lat"/>
                            <input class="h100" style="width: 48%;margin-left: 4%" type="text" placeholder="请输入Y坐标" v-model="data.location.lng"/>
                        </div>
                    </div>

                    <div class="fl item txt_black54 f14 bold500">
                        <div class="title bold600 content-center">
                            <Icon type="ios-star"/>
                            点位地址：
                        </div>
                        <div class="ipt">
                            <input class="w100 h100" type="text" placeholder="请输入点位地址" v-model="data.address"/>
                        </div>
                    </div>

                    <div class="map fr" id="mapContainer"></div>

<!--                    <div class="fl item txt_black54 f14 bold500">-->
<!--                        <div class="title bold600 content-center">-->
<!--                            <Icon type="ios-star"/>-->
<!--                            合伙人：-->
<!--                        </div>-->
<!--                        <div class="ipt">-->
<!--                            <selection :options="partners" v-model="partner" @change="partnerChange"></selection>-->
<!--                        </div>-->
<!--                    </div>-->
                    <div class="fl item txt_black54 f14 bold500">
                        <div class="title bold600 content-center">
                            维护人员：
                        </div>
                        <div class="ipt">
                            <input class="w100 h100" type="text" placeholder="维护人员只可显示，不可填写" v-model="data.maintainer" disabled/>
                        </div>
                    </div>
                    <div class="fl item txt_black54 f14 bold500">
                        <div class="title bold600 content-center">
                            通信MAC：
                        </div>
                        <div class="ipt">
                            <input class="w100 h100" type="text" placeholder="请输入通信MAC-WIFI" v-model="data.mac"/>
                        </div>
                    </div>
                </div>
                <div class="submit tc">
                    <button class="bg_1890FF f18 bold400 txt_white tc cursor_pointer" @click="page+=1">下一页</button>
                </div>
            </div>

            <div v-show="page===1">
                <div class="content door f14 txt_black85 bold500">
                    <div class="title txt_black54 f12 bold500 bold600 content-center">
                        柜门型号0:超大柜,1:大柜,2:中柜,3:小柜,4:超小柜
                    </div>
                    <ul class="f14 title"><li>柜门编号</li><li>柜门型号</li><li>板卡id</li><li>通道id</li></ul>
                    <ul class="f12" v-for="(v,key) in data.doors" :key="key">
                        <li>
                            <input type="text" v-model="v.no" :disabled="flag==='edit'"/>
                        </li>
                        <li>
                            <input type="text" v-model="v.type" :disabled="flag==='edit'"/>
                        </li>
                        <li>
                            <input type="text" v-model="v.cid" :disabled="flag==='edit'"/>
                        </li>
                        <li>
                            <input type="text" v-model="v.ch" :disabled="flag==='edit'"/>
                        </li>
                        <li v-if="flag==='create'&&key===data.doors.length-1">
                            <Icon type="md-add-circle" size="30" color="rgba(31,144,255)" class="cursor_pointer" @click="addDoorEvent" />
                            <Icon v-if="key>0" type="md-remove-circle" size="30" color="#E91E63" class="cursor_pointer" @click="removeDoorEvent" />
                        </li>
                    </ul>
                </div>
                <div class="submit tc">
                    <button class="bg_1890FF f18 bold400 txt_white tc cursor_pointer" @click="page-=1">上一页</button>
                    <button class="bg_1890FF f18 bold400 txt_white tc cursor_pointer" @click="page+=1">下一页</button>
                </div>
            </div>
            <div v-show="page===2">
                <div class="content door f14 txt_black85 bold500">
                    <div class="fl item txt_black54 f14 bold500">
                        <div class="title bold600 content-center">
                            <Icon type="ios-star"/>
                            计费类别：
                        </div>
                        <div class="ipt">
                            <selection :options="$config.billType.getItem(1)" v-model="billType" @change="billChange"></selection>
                        </div>
                    </div>

                    <div class="fl table w100 f14 txt_black85 bold500" v-if="billType==='时长'">
                        <ul><li>柜门</li><li>起始价格</li><li>单价</li><li>最大金额</li></ul>
                        <ul v-for="(v,key) in data.bill" :key="key">
                            <li v-text="$config.doorType.get(parseInt(key))"></li>
                            <li>
                                <div class="ipt fl">
                                    <input type="number" min="0" v-model="v[0].time" />
                                    <div class="fr">小时</div>
                                </div>
                                <div class="ipt fr">
                                    <input type="number" min="0" v-model="v[0].price" />
                                    <div class="fr">元</div>
                                </div>
                            </li>
                            <li>
                                <div class="ipt fl">
                                    <input type="number" min="0" v-model="v[1].price" />
                                    <div class="fr">元</div>
                                </div>
                            </li>
                            <li>
                                <div class="ipt fl">
                                    <input type="number" min="0" v-model="v[2].time" />
                                    <div class="fr">小时</div>
                                </div>
                                <div class="ipt fr">
                                    <input type="number" min="0" v-model="v[2].price" />
                                    <div class="fr">元</div>
                                </div>
                            </li>
                        </ul>
                    </div>

                    <div class="fl table timeTable w100 f14 txt_black85 bold500" v-if="billType==='次数'">
                        <ul><li>柜门</li><li>单次时长</li><li>单价</li><li>最大金额</li></ul>
                        <ul v-for="(v,key) in data.bill" :key="key">
                            <li v-text="$config.doorType.get(parseInt(key))"></li>
                            <li>
                                <div class="ipt fl">
                                    <input type="number" min="0" v-model="v[0].time" />
                                    <div class="fr">小时</div>
                                </div>
                            </li>
                            <li>
                                <div class="ipt fl">
                                    <input type="number" min="0" v-model="v[0].price" />
                                    <div class="fr">元</div>
                                </div>
                            </li>
                            <li>
                                <div class="ipt fl">
                                    <input type="number" min="0" v-model="v[1].price" />
                                    <div class="fr">元</div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="submit tc">
                    <button class="bg_1890FF f18 bold400 txt_white tc cursor_pointer" @click="page-=1">上一页</button>
                    <button class="bg_E91E63 f18 bold400 txt_white tc cursor_pointer" @click="submit">提交</button>
                </div>
            </div>

        </div>
    </div>
</template>
<!--

-->
<script>
    export default {
        name: "pointDetail",
        data() {
            return {
                show: false,
                flag: 'create',
                page: 0,
                billType: '时长',
                partners: null,
                partner: '',
                bill0: {
                    0: [
                        {
                            time: 2,
                            price: null,
                        },
                        {
                            time: 1,
                            price: null,
                        },
                        {
                            time: 24,
                            price: null
                        }
                    ],
                    1: [
                        {
                            time: 2,
                            price: null,
                        },
                        {
                            time: 1,
                            price: null,
                        },
                        {
                            time: 24,
                            price: null
                        }
                    ],
                    2: [
                        {
                            time: 2,
                            price: null,
                        },
                        {
                            time: 1,
                            price: null,
                        },
                        {
                            time: 24,
                            price: null
                        }
                    ],
                    3: [
                        {
                            time: 2,
                            price: null,
                        },
                        {
                            time: 1,
                            price: null,
                        },
                        {
                            time: 24,
                            price: null
                        }
                    ],
                    4: [
                        {
                            time: 2,
                            price: null,
                        },
                        {
                            time: 1,
                            price: null,
                        },
                        {
                            time: 24,
                            price: null
                        }
                    ]
                },
                bill1: {
                    0: [
                        {
                            time: 2,
                            price: null,
                        },
                        {
                            time: 1,
                            price: null,
                        }
                    ],
                    1: [
                        {
                            time: 2,
                            price: null,
                        },
                        {
                            time: 1,
                            price: null,
                        }
                    ],
                    2: [
                        {
                            time: 2,
                            price: null,
                        },
                        {
                            time: 1,
                            price: null,
                        }
                    ],
                    3: [
                        {
                            time: 2,
                            price: null,
                        },
                        {
                            time: 1,
                            price: null,
                        }
                    ],
                    4: [
                        {
                            time: 2,
                            price: null,
                        },
                        {
                            time: 1,
                            price: null,
                        }
                    ]
                },
                defaultData: {
                    project_id: '',
                    id: '',
                    name: '',
                    location: {
                        lat: '',
                        lng: ''
                    },
                    address: '',
                    partner: '',
                    maintainer: '',
                    mac: '',
                    doors: [
                        {
                            no: '',
                            type: '',
                            cid: '',
                            ch: ''
                        }
                    ],
                    bill_type: 0,
                    bill: {}
                },
                data: {}
            }
        },
        created() {
            this.data = this.defaultData;
            this.loadMap();
        },
        methods: {
            init(flag,data) {
                this.flag = flag;
                this.show = true;
                this.page = 0;
                if(this.flag === 'edit') {
                    for (let v in this.data) {
                        this.data[v] = data[v];
                    }
                    this.billType = this.$config.billType.get(data.bill_type);
                    this.billType === '时长' ? this.bill0 = JSON.parse(JSON.stringify(data.bill)) : this.bill1 = JSON.parse(JSON.stringify(data.bill));
                }else {
                    this.data = this.defaultData;
                    for (let v in data) {
                        this.data[v] = data[v];
                    }
                    this.data.bill = this.billType === '时长' ? JSON.parse(JSON.stringify(this.bill0)) : JSON.parse(JSON.stringify(this.bill1));
                }
            },
            getPartners() {
                this.partner = '';
                this.$api.get('/manage/partner').then((data) => {
                    this.partners = data.data.map((item) => {
                        return {
                            id: item.id,
                            text: item.name
                        }
                    });
                }).catch((error) => {
                    this.$alert.error({content: '获取合伙人列表失败'});
                });
            },
            partnerChange(data) {
                this.data.partner = data ?  data.id : '';
            },
            loadMap() {
                var script = document.createElement("script");
                script.type = "text/javascript";
                script.src = "https://map.qq.com/api/js?v=2.exp&key=IR4BZ-CJG6W-FRDR2-RMIB6-4N5OT-4RFOS&callback=init";
                document.body.appendChild(script);
                window.init = () => {
                    let myLatlng = new qq.maps.LatLng(30.541502016229398,104.07596100781248);
                    let myOptions = {
                        zoom: 8,
                        center: myLatlng,
                        mapTypeId: qq.maps.MapTypeId.ROADMAP
                    };
                    let map = new qq.maps.Map(document.getElementById("mapContainer"), myOptions);

                    let marker = new qq.maps.Marker({
                        position: myLatlng,
                        draggable: true,
                        map: map
                    });
                    qq.maps.event.addListener(marker, 'dragend', (event) => {
                        this.data.location.lat = event.latLng.getLat();
                        this.data.location.lng = event.latLng.getLng();
                    });
                }
            },
            billChange() {
                this.data.bill = this.billType === '时长' ? JSON.parse(JSON.stringify(this.bill0)) : JSON.parse(JSON.stringify(this.bill1));
            },
            addDoorEvent() {
                this.data.doors.push({
                    no: '',
                    type: '',
                    cid: '',
                    ch: ''
                })
            },
            removeDoorEvent() {
                this.data.doors.pop();
            },
            setBillData() {
                this.data.bill_type = this.$config.billType.get(this.billType);
                for (let v in this.data.bill) {
                    this.data.bill[v].forEach(item => {
                        item.price = parseFloat(item.price);
                        item.time = parseFloat(item.time);
                    })
                }
            },
            submit() {
                this.setBillData();
                if(this.flag === 'create'){
                    this.$api.post('/manage/point',this.data).then((data) => {
                        this.$alert.success({content: '新建成功'});
                        this.show = false;
                        this.$emit('updateData');
                    }).catch((error) => {
                        this.$alert.error({content: '新建失败，请重试'});
                    });
                }else {
                    this.$api.put('/manage/point/' + this.data.id,this.data).then((data) => {
                        this.$alert.success({content: '修改成功'});
                        this.show = false;
                        this.$emit('updateData');
                    }).catch((error) => {
                        this.$alert.error({content: '修改失败，请重试'});
                    });
                }
            }
        }
    }
</script>

<style scoped>
    .pointDetail {
        width: 700px;
    }

    .content {
        padding: 10px 20px 0 20px;
        height: 440px;
        overflow: auto;
    }

    .map{
        width: 300px;
        height: 240px;
        margin-top: 20px;
    }

    .content > .item {
        margin-top: 20px;
        width: 300px;
    }

    .content > .item > div:nth-of-type(2)>:first-child{
        height: 36px;
        line-height: 36px;
        margin-top: 8px;
    }

    .content > .item > .ipt > input {
        border: 1px solid rgba(204, 204, 204, 1);
        border-radius: 3px;
        padding: 0 10px;
        height: 36px;
        line-height: 36px;
        margin-top: 8px;
    }

    .door>ul{
        margin-top: 10px;
        overflow: hidden;
    }
    .door>ul>li{
        float: left;
        width: 20%;
        height: 30px;
        line-height: 30px;
        padding-right: 10px;
    }
    .door>ul>li>input{
        width: 100%;
        height: 100%;
        border: 1px solid rgba(204, 204, 204, 1);
        border-radius: 5px;
        outline: medium;
    }

    .table{
        margin-top: 30px;
        overflow: auto;
    }

    .table>ul{
        margin-top: 10px;
        overflow: hidden;
    }
    .table>ul>li{
        float: left;
        width: 12%;
        text-align: left;
        height: 30px;
        line-height: 30px;
    }
    .table>ul>li:nth-of-type(2),.table>ul>li:nth-of-type(4){
        width: 30%;
    }
    .table>ul>li:nth-of-type(3) {
        margin: 0 8%;
    }
    .timeTable>ul>li:nth-of-type(2),.timeTable>ul>li:nth-of-type(3),.timeTable>ul>li:nth-of-type(4) {
        width: 29%;
        margin: 0;
    }

    .table>ul>li>i{
        line-height: 30px;
    }
    .table>ul>li>.ipt{
        height: 30px;
        line-height: 28px;
        border: 1px solid rgba(204, 204, 204, 1);
        border-radius: 5px;
    }
    .table>ul>li>span{
        padding: 0 5px;
    }
    .table>ul>li .ipt>input{
        width: 50px;
        outline: medium;
        display: block;
        text-align: center;
        float: left;
    }
    .table>ul>li .ipt>div{
        height: 28px;
        background-color: #D9D9D9;
        color:rgba(0,0,0,0.65);
        padding: 0 5px;
    }

    .submit>button{
        width: 200px;
    }
    .submit>button:nth-of-type(2){
        margin-left: 20px;
    }
</style>